import { Component, inject, computed } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../services/auth.service';

interface MenuItem {
  label: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
  private readonly authService = inject(AuthService);

  readonly menuItems = computed<MenuItem[]>(() => {
    const role = this.authService.role();
    const isUser = role === 'RESALE_USER';

    return [
      { label: 'Visão geral', route: '/notices', icon: 'assets/icons/24px/noticias.svg' },
      ...(!isUser ? [{ label: 'Módulos', route: '/modules', icon: 'assets/icons/24px/formacoes.svg' }] : []),
      { label: 'Trilhas', route: isUser ? '/track-enrollments' : '/tracks', icon: 'assets/icons/24px/trilha.svg' },
      ...(!isUser ? [{ label: 'Usuários', route: '/users', icon: 'assets/icons/24px/usuarios.svg' }] : []),
    ];
  });
}
